import React from 'react';
// import { Icon } from '/imports/ui/Icon';

// Native appearance with accent-color, rather than appearance-none plus a
// hand-painted fill. The old version drew a 24px solid green square with no
// checkmark at all (the Icon that was supposed to supply one is commented out),
// so a ticked box and a disabled box looked nearly identical. Letting the
// platform draw it gives a real checkmark, correct focus behaviour and the right
// size, and accent-primary still tracks the theme token.
const inputClassName = [
  'relative top-[-0.05rem] mr-2 h-4 w-4 shrink-0 cursor-pointer accent-primary',
  'disabled:cursor-not-allowed disabled:opacity-60',
].join(' ');

export interface CheckboxProps {
  id?: string;
  className?: string;
  checked?: boolean;
  onChange?(checked: boolean, e: React.ChangeEvent<HTMLInputElement>): void;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const Checkbox = (props: CheckboxProps) => {
  return (
    <label className="relative">
      <input
        id={props.id}
        className={`checkbox-label ${inputClassName} ${props.className}`}
        type='checkbox'
        checked={props.checked}
        disabled={props.disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.onChange?.(e.target.checked, e)}
      />
      {/* {
        props.checked ?
          <Icon className="checkmark" icon="check" />
          :
          null
      } */}
      {props.children || null}
    </label>
  );
};